'use strict';

const isTransparentEnabled = $('.homePageTransparentHeader').val() === 'true';
const $header = $('.header');

function stickyHeaderFcn() {
    const body = document.body;
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    let lastScroll = 0;
    let upTotal = 0;
    let downTotal = 0;

    window.addEventListener("scroll", () => {
        let currentScroll = window.pageYOffset;
        if (currentScroll <= 0 || $header.hasClass('suggestion-show')) {
            if (isTransparentEnabled) {
                $header.addClass('transparent');
                if ($('html').hasClass('is--header-search-show') || $('html').hasClass('is--menu-active') || $('.js-header-inner').hasClass('menu-expanded')) {
                    $header.removeClass('transparent');
                }
            }
            body.classList.remove(scrollUp);
            return;
        } else if(isTransparentEnabled) {
            $header.removeClass('transparent');
        }
        
        //Global Header show/hide on scroll up and down
        if (currentScroll > lastScroll && !body.classList.contains('mini-cart-show')) {
            upTotal = 0;
            downTotal += (currentScroll - lastScroll);
            if (downTotal >= 200) {
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
                $header.addClass('hide');
            }
        } else {
            downTotal = 0;
            upTotal += (lastScroll - currentScroll); 
            if (upTotal >= 25) {
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
                $header.removeClass('hide');
            }
        }
        lastScroll = currentScroll;

        // PLP sticky header functionality
        if($('.pt_product-search-result').length > 0) {
            setTimeout(function() {
                let filterPosition = $('.filters-sticky .c-product-filters').offset().top;
                let headerHeight = $('.header').height();
                let $filterSticky = $('.filters-sticky');
                currentScroll = window.pageYOffset;
                if(currentScroll >= (filterPosition - headerHeight)) {
                    $filterSticky.addClass('sticky-state');
                    if($header.hasClass('hide')) {
                        $filterSticky.removeClass('hide');
                    } else {
                        $filterSticky.addClass('hide');
                    }
                } else {
                    $filterSticky.removeClass('sticky-state');
                    $filterSticky.removeClass('hide');
                }
            }, 500);
        }

        // PDP fixed image
        if($('.c-product-details__images').length > 0) {
            let viewportWidth = $(window).width();
            if(viewportWidth < 992) {
                const windowHeight = window.innerHeight;
                if (windowHeight > currentScroll) {
                    $('.c-product-details__images').removeClass('invisible');
                } else {
                    $('.c-product-details__images').addClass('invisible');
                }
            } else {
                $('.c-product-details__images').removeClass('invisible');
            }
        }

    });
}

function calcHeaderHeight() {
    if ($header.length > 0 && !isTransparentEnabled) {
        $('.thirdLevels').removeClass('active');
        let headerHeight = $header.outerHeight();
        if ($('div.c-product-result__wrapper').length > 0) {
            $('div.c-product-result__wrapper').css('margin-top', headerHeight);
        } else {
            $('#main').css('margin-top', headerHeight);
        }
    }
}

function stickyOrderSummarySection(){
    let $headerHeight = Math.trunc($('#header').outerHeight());
    $('.js-cart-summary-wrapper').css('top',$headerHeight);
}

module.exports = {
    init: function() {
        var currentScroll = $(window).scrollTop();
        if (!(currentScroll > 0) && isTransparentEnabled) {
            $header.addClass('transparent');
        } else {
            $header.removeClass('transparent');
        }
        stickyHeaderFcn();
        $(window).on('load', function() {
            calcHeaderHeight();
        });
        setTimeout(function() {
            calcHeaderHeight();
        }, 2000);
        stickyOrderSummarySection();
    }
}
